import { ClareSystem } from "@app/project/model/clare-system";
import { CallState, LoadingState } from "@app/root-store/api-result.state";
import { User } from "@app/user/model/user";

export interface CustomerLocationClaresystemsState {
    result: ClareSystem[];
    customerId: number;
    callState: CallState<{ claresystem: ClareSystem }[]>;
}

export interface CustomerLocationUsersState {
    result: { userinfo: User }[];
    callState: CallState<{ userinfo: User }[]>;
}

export interface CustomerLocationDataState {
    result: { timezone: string; coordinates: string };
    uuid: string;
    callState: CallState<{ timezone: string; coordinates: string }>;
}

export interface CustomerLocationState {
    claresystems: CustomerLocationClaresystemsState;
    users: { [uuid: string]: CustomerLocationUsersState };
    customerRoleId: number;
    locationData: { [uuid: string]: CustomerLocationDataState };
}

export const initialCustomerLocationUsersState = { result: null, callState: LoadingState.init };

export const initialState = {
    claresystems: { result: null, customerId: null, callState: LoadingState.init },
    users: {},
    customerRoleId: null,
    locationData: {},
};
